import { Tooltip } from '@mui/material';
import React from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';
import logo from '../../../../images/mobilecomm.png';
import logo2 from '../../../../images/mpag_Logo.f508768e.png';

class PDFExport extends React.Component {
    exportToPDF = () => {
        const { data, header } = this.props.table;

        // Debugging: Check data structure
        console.log("Header:", header);
        console.log("Data:", data);

        // Create a new jsPDF document
        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.getWidth();

        // Add Cover Page
        doc.setFontSize(26);
        doc.setTextColor(0, 102, 204);
        doc.text("Data Exported", pageWidth / 2, 80, { align: 'center' });
        doc.setFontSize(18);
        doc.setTextColor(0, 0, 0);
        doc.text("Generated by Mobilecomm, a UST Company", pageWidth / 2, 100, { align: 'center' });
        doc.setFontSize(14);
        doc.text("Date: " + new Date().toLocaleDateString(), pageWidth / 2, 120, { align: 'center' });

        // Add page break after cover page
        doc.addPage();

        // Add a title to the table page
        doc.setFontSize(22);
        doc.setTextColor(0, 102, 204);
        doc.text("Exported Data", 14, 16);

        // Map data correctly
        const tableBody = data.map(item => {
            return header.map(h => {
                const value = item[h];
                return value === undefined || value === null || value === '' ? 'N/A' : value; 
            });
        });

        // Debugging: Check table body structure
        console.log("Table Body:", tableBody);

        // Use autoTable to generate a table in the PDF
        doc.autoTable({
            head: [header],
            body: tableBody,
            startY: 30,
            theme: 'grid',
            styles: {
                fillColor: [240, 240, 240],
                textColor: [0, 0, 0],
                fontSize: 12,
                lineWidth: 0.5,
                lineColor: [200, 200, 200],
                cellPadding: 4,
            },
            margin: { bottom: 30 },
        });

        // Delay to ensure everything renders properly
        setTimeout(() => {
            const chartContainer = document.getElementById('export-container');
            html2canvas(chartContainer).then(canvas => {
                const imgData = canvas.toDataURL('image/png');
                doc.addPage();
                doc.addImage(imgData, 'PNG', 10, 10, 190, 100);

                // Add footer with text and logos on every page
                const pageCount = doc.internal.getNumberOfPages();
                for (let i = 1; i <= pageCount; i++) {
                    doc.setPage(i);
                    doc.setFontSize(10);
                    doc.setTextColor(100, 100, 100);
                    doc.text('Mobilecomm a UST Company', pageWidth / 2, doc.internal.pageSize.getHeight() - 10, { align: 'center' });

                    // Position and add the first logo on the left
                    const imgWidth = 40;
                    const imgHeight = 20;
                    const xPosition = 10; // Left margin
                    const yPosition = doc.internal.pageSize.getHeight() - imgHeight - 25; // Above footer
                    doc.addImage(logo, 'PNG', xPosition, yPosition, imgWidth, imgHeight);

                    // Position and add the second logo on the right
                    const imgWidth2 = 40; // Adjust as needed
                    const imgHeight2 = 20; // Adjust as needed
                    const xPosition2 = pageWidth - imgWidth2 - 10; // Right margin
                    const yPosition2 = doc.internal.pageSize.getHeight() - imgHeight2 - 25; // Same vertical position
                    doc.addImage(logo2, 'PNG', xPosition2, yPosition2, imgWidth2, imgHeight2);
                }

                // Save the PDF
                doc.save("data.pdf");
            });
        }, 1000);
    }

    render() {
        return (
            <Tooltip title="Export To PDF">
                <svg
                    style={{
                        position: "absolute",
                        right: "140px",
                        top: "83px",
                        cursor: 'pointer',
                    }}
                    onClick={this.exportToPDF}
                    width="30px"
                    height="30px"
                    className="w-6 h-6 text-gray-800 dark:text-white"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                >
                    <path
                        fillRule="evenodd"
                        d="M9 2.221V7H4.221a2 2 0 0 1 .365-.5L8.5 2.586A2 2 0 0 1 9 2.22ZM11 2v5a2 2 0 0 1-2 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2 2 2 0 0 0 2 2h12a2 2 0 0 0 2-2 2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2V4a2 2 0 0 0-2-2h-7Zm-6 9a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-1h.5a2.5 2.5 0 0 0 0-5H5Zm1.5 3H6v-1h.5a.5.5 0 0 1 0 1Zm4.5-3a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1.376A2.626 2.626 0 0 0 15 15.375v-1.75A2.626 2.626 0 0 0 12.375 11H11Zm1 5v-3h.375a.626.626 0 0 1 .625.626v1.748a.625.625 0 0 1-.626.626H12Zm5-5a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1v-1h1a1 1 0 1 0 0-2h-2Z"
                        clipRule="evenodd"
                    />
                </svg>
            </Tooltip>
        );
    }
}

export default PDFExport;